import{getQuestionnaireSections,normalizeQuestionnaireSections}from'./questionnaireSections';

const STORAGE_KEY='amp-questionnaire-templates';

const templateDefinitions=[
  {
    id:'wedding',
    name:'Wedding',
    eventType:'Wedding',
    description:'A complete wedding questionnaire covering ceremony music,venue logistics,timeline,reception,and playlists.'
  },
  {
    id:'bar-bat-mitzvah',
    name:'Bar/Bat Mitzvah',
    eventType:'Bar Mitzvah',
    description:'A mitzvah-focused questionnaire with reception traditions,games,candle lighting,and music planning.'
  },
  {
    id:'corporate-event',
    name:'Corporate Event',
    eventType:'Corporate Event',
    description:'A flexible corporate event questionnaire for production requirements,venue details,timing,and entertainment.'
  },
  {
    id:'birthday',
    name:'Birthday',
    eventType:'Other',
    description:'A birthday celebration questionnaire for themes,music,traditions,guests,venue needs,and special moments.'
  }
];

function clone(value){
  return JSON.parse(JSON.stringify(value));
}

function copyDancingMusicQuestion(templates){
  const weddingTemplate=templates.find(
    (template)=>template.id==='wedding'
  );
  const mitzvahTemplate=templates.find(
    (template)=>template.id==='bar-bat-mitzvah'
  );

  if(!weddingTemplate||!mitzvahTemplate){
    return templates;
  }

  const weddingMusicSection=weddingTemplate.sections.find(
    (section)=>section.id==='music'
  );
  const mitzvahMusicSection=mitzvahTemplate.sections.find(
    (section)=>section.id==='music'
  );

  if(!weddingMusicSection||!mitzvahMusicSection){
    return templates;
  }

  const sourceQuestion=weddingMusicSection.questions.find(
    (question)=>
      question.id==='danceGenres'||
      question.title.toLowerCase()==='dancing music'
  );

  const alreadyCopied=mitzvahMusicSection.questions.some(
    (question)=>
      question.id==='danceGenres'||
      question.title.toLowerCase()==='dancing music'
  );

  if(!sourceQuestion||alreadyCopied){
    return templates;
  }

  const copiedQuestion={
    ...clone(sourceQuestion),
    id:'danceGenres',
    title:'Dancing music'
  };

  const dinnerIndex=mitzvahMusicSection.questions.findIndex(
    (question)=>question.id==='dinnerGenres'
  );

  const insertAt=dinnerIndex>=0
    ?dinnerIndex+1
    :mitzvahMusicSection.questions.length;

  mitzvahMusicSection.questions.splice(insertAt,0,copiedQuestion);
  mitzvahTemplate.updatedAt=new Date().toISOString();

  return templates;
}

function normalizeTemplate(template){
  const normalizedSections=normalizeQuestionnaireSections(
    template.sections,
    template.eventType
  );

  return{
    ...template,
    sections:normalizedSections
  };
}

function createDefaultTemplates(){
  const templates=templateDefinitions.map((definition)=>({
    ...definition,
    sections:getQuestionnaireSections(definition.eventType),
    updatedAt:new Date().toISOString()
  }));

  return copyDancingMusicQuestion(templates);
}

function writeTemplates(templates){
  localStorage.setItem(STORAGE_KEY,JSON.stringify(templates));
}

function readTemplates(){
  try{
    const stored=localStorage.getItem(STORAGE_KEY);

    if(stored!==null){
      const templates=Array.isArray(JSON.parse(stored))
        ?JSON.parse(stored)
        :[];

      const updatedTemplates=copyDancingMusicQuestion(
        templates.map(normalizeTemplate)
      );

      if(
        JSON.stringify(updatedTemplates)!==
        JSON.stringify(templates)
      ){
        writeTemplates(updatedTemplates);
      }

      return updatedTemplates;
    }

    const defaults=createDefaultTemplates();
    writeTemplates(defaults);
    return defaults;
  }catch{
    const defaults=createDefaultTemplates();
    writeTemplates(defaults);
    return defaults;
  }
}

export function getQuestionnaireTemplates(){
  return clone(readTemplates());
}

export function updateQuestionnaireTemplate(templateId,sections){
  const templates=readTemplates().map((template)=>
    template.id===templateId
      ?{
        ...template,
        sections:clone(sections),
        updatedAt:new Date().toISOString()
      }
      :template
  );

  writeTemplates(templates);

  return templates.find(
    (template)=>template.id===templateId
  )||null;
}

export function duplicateQuestionnaireTemplate(templateId){
  const templates=readTemplates();
  const source=templates.find(
    (template)=>template.id===templateId
  );

  if(!source){
    return null;
  }

  const duplicate={
    ...clone(source),
    id:`questionnaire-${Date.now()}`,
    name:`${source.name} copy`,
    sections:clone(source.sections),
    createdAt:new Date().toISOString(),
    updatedAt:new Date().toISOString()
  };

  writeTemplates([duplicate,...templates]);
  return duplicate;
}

export function deleteQuestionnaireTemplate(templateId){
  const templates=readTemplates();
  const nextTemplates=templates.filter(
    (template)=>String(template.id)!==String(templateId)
  );

  if(nextTemplates.length===templates.length){
    return false;
  }

  writeTemplates(nextTemplates);
  return true;
}

export function resetQuestionnaireTemplates(){
  const templates=createDefaultTemplates();
  writeTemplates(templates);
  return clone(templates);
}